<template>
    <div class="table">
        <div style="font-size: 13px;color:red">注：每次查询仅限1个学年范围内的统计数据，不能跨学年。</div>
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:310px;">
                    <el-date-picker
                        v-model="form.startDate"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 150px;"
                        type="date"
                        placeholder="开始日期"
                        @change="startDateChangeEvent">
                    </el-date-picker>

                    <el-date-picker
                        v-model="form.endDate"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 150px;"
                        type="date"
                        placeholder="结束日期"
                        :picker-options="limitDate(form.startDate)">
                    </el-date-picker>
                </div>
            </div>
            &nbsp;
            <el-button type="primary" icon="search" @click="getData()">查询</el-button>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="success" @click="queryDate(5)" v-if="form.dateType == 5">最近30天 </el-button>
                <el-button type="success" plain @click="queryDate(5)" v-if="form.dateType != 5">最近30天 </el-button>
                <el-button type="success" plain @click="queryDate(4)">最近7天</el-button>
                <el-button type="success" plain @click="queryDate(3)">昨天</el-button>
                <el-button type="success" plain @click="queryDate(2)">今天</el-button>
                <el-button type="success" plain @click="queryDate(6)">本周</el-button>
                <el-button type="success" plain @click="queryDate(7)">上周</el-button>
                <el-button type="success" plain @click="queryDate(1)">本月</el-button>
                <el-button type="success" plain @click="queryDate(0)">上月</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="title" label="名称"  :show-overflow-tooltip="true" width="130"></el-table-column>
                <el-table-column prop="" label="评分类型" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.scoreType == 1">
                            五育项目
                        </div>
                        <div v-else-if="scope.row.scoreType == 2">
                            复合积分
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="rateSet" label="综合比例设置" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="rangeSet" label="评比范围" :show-overflow-tooltip="true"  width="150"></el-table-column>
                <el-table-column prop="gradeName" label="年级名称" width="100"></el-table-column>
                <el-table-column prop="className" label="班级名称" width="100"></el-table-column>
                <el-table-column prop="score" label="值" width="100"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="showData(scope.row)"
                            type="text"
                            size="small"  v-if="scope.row.name != '无'">
                            <span style="color: #387EE8;">详情</span>
                        </el-button>
                        <el-button  @click.native.prevent="exportExcel(scope.row)"
                            type="text"
                            size="small"  v-if="scope.row.name != '无'">
                            <span style="color: #387EE8;">导出</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 统计详情弹出框 -->
        <div v-if="classEvaluateInfoVisible">
            <classEvaluateInfo ref="classEvaluateInfo"></classEvaluateInfo>
        </div>
        <!-- 导出配置弹出框 -->
        <div v-if="classEvaluateExprotVisible">
            <classEvaluateExprot ref="classEvaluateExprot"></classEvaluateExprot>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http'; 
    import classEvaluateInfo from './ClassEvaluateInfo.vue';
    import classEvaluateExprot from './ClassEvaluateExprot.vue';

    export default {
        name:"",
        data(){
            return{
                loading:false,
                loadingText:"",
                classEvaluateInfoVisible:false,
                classEvaluateExprotVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    dateType:5,
                    // 时间限制在，查询最多控制在一年内。
                    startDate:"",
                    endDate:"",
                },
                data:[],
                depts:[],
            }
        },
        components: {
            classEvaluateInfo,classEvaluateExprot
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            // 日期限制控制在1年内，查询方法。
            limitDate(sDate) {
                if(sDate){
                    let now = new Date(sDate);
                    let obj = {
                        disabledDate(time) {
                            let parts = sDate.split('-');
                            let date = new Date();
                            date.setFullYear(parts[0]); // 设置年份
                            date.setMonth(parts[1] - 1); // 设置月份（月份从0开始，所以要减1）
                            date.setDate(parts[2]-1); // 设置日期
                            let startDate = date.getTime()
                            // console.log('结束日期', startDate)
                            // 开始日期的，限制在1年内
                            let endDate = new Date(now.getFullYear()+1,now.getMonth(),now.getDate()).getTime()
                            return time.getTime() > endDate || time.getTime() < startDate
                        }
                    }
                    return obj
                }else{
                    return {}
                }
            },
            startDateChangeEvent(){
                // console.log('开始日期变动，触发事件',this.form.startDate)
                this.form.endDate = "";
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        // 最近30天
                        this.queryDate(5);
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){

                let startDate = this.form.startDate;
                let endDate = this.form.endDate;
                console.log('startDate',startDate);
                console.log('endDate',endDate);

                if(!startDate || !endDate){
                    this.$commonFn.showTip('开始日期或者结束日期不可为空',3);
                    return;
                }

                this.loading=true;
                this.loadingText="正在加载中...";

                let url  = this.honorSetListCountArchiveUrl;
                let data = {
                    deptId:this.form.deptId,
                    evaluateTarget:1, // 荣誉目标（1-班级，2-学生）
                    startDate: startDate,
                    endDate: endDate,
                };
                console.log("请求参数："+JSON.stringify(data));
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            // 获取日期
            queryDate(dateType){
                // this.$forceUpdate();
                this.form.dateType=dateType;
                let url  = this.honorSetQueryDateUrl;
                let data = {
                    dateType:this.form.dateType //dateType:0-上月，1-本月，2-今天，3-昨天，4-最近7天，5-最近30天
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.form.startDate=res.data.startDate;
                       this.form.endDate=res.data.endDate;
                       // 查询数据
                       this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            //详情界面
            showData(data){
                let startDate = this.form.startDate;
                let endDate = this.form.endDate;

                if(!startDate || !endDate){
                    this.$commonFn.showTip('开始日期或者结束日期不可为空',3);
                    return;
                }

                this.classEvaluateInfoVisible=true;
                this.$nextTick(() => {
                    this.$refs['classEvaluateInfo'].init(data.id,startDate,endDate);
                })
            },
            // 导出
            exportExcel(data){
                let startDate = this.form.startDate;
                let endDate = this.form.endDate;

                if(!startDate || !endDate){
                    this.$commonFn.showTip('开始日期或者结束日期不可为空',3);
                    return;
                }

                this.classEvaluateExprotVisible=true;
                this.$nextTick(() => {
                    this.$refs['classEvaluateExprot'].init(data,startDate,endDate);
                })
           },
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluateArchive/ClassEvaluateCount.vue